const main = {
      default: `
      Na našem webu používáme cookies, které slouží k zajištění správného fungování a bezpečnosti stránek. 
      Díky nim také víme, co vás zajímá, a můžeme tak neustále vylepšovat náš obsah. 
      Kliknutím na tlačítko „Přijmout vše“ souhlasíte s jejich využitím. Svůj souhlas však můžete kdykoli změnit nebo zrušit.`,
      en: 'We use cookies on our website to ensure proper functioning and security of the site. They also help us understand what interests you, allowing us to constantly improve our content. By clicking the "Accept All" button, you agree to their use. However, you can change or revoke your consent at any time.',
}

const requiredTitle = {
  default: `Nezbytné soubory cookies`,
  en: `Essential Cookies`
}

const required = {
  default: `Nezbytné cookies pomáhají, aby naše webová stránka fungovala správně a bezpečně. Nesbírají osobní údaje ani nesledují vaše chování na internetu.`,
  en: `Essential cookies help our website function properly and securely. They do not collect personal data or track your online behavior.`
}

const statsTitle = {
  default: `Statistické a analytické cookies`,
  en: `Statistical and Analytical Cookies`
}


const stats = {
  default: `Statistické a analytické cookies nám pomáhají rozumět, jak náš web používáte. Informace jsou sbírány anonymně.`,
  en: `Statistical and analytical cookies help us understand how you use our site. The information is collected anonymously.`
}

const marketingTitle = {
  default: `Marketingové cookies`,
  en: `Marketing Cookies`
}


const marketing = {
  default: `Marketingové cookies se užívají za účelem poskytování personalizované reklamy. Tyto soubory shromažďují informace napříč webovými stránkami.`,
  en: `Marketing cookies are used to provide personalized advertising. These files collect information across websites.`
}


const accept = {
  default: `přijmout`,
  en: `accept`
}


const acceptAll = {
  default: `přijmout vše`,
  en: `accept all`
}


const acceptRequired = {
  default: `přijmout nezbytné`,
  en: `accept necessery`
}

const customize = {
  default: `přizpůsobit`,
  en: `customize`
}

export const CookieText = {
  main,
  required, requiredTitle,
  stats, statsTitle,
  marketing, marketingTitle,
  accept, acceptAll, acceptRequired, customize
}















